import React from 'react'
import classNames from 'classnames'
import classes from './AuthReminder.module.css'
import Modal from './Modal'
import { Button, ButtonVariants } from '../Button/Button'
import { useDispatch } from 'react-redux'
import { useHistory, useLocation } from 'react-router'
import { userActions } from '../../redux/userSlice'

export function AuthRemider({
    open = false,
    onRequestDismiss,
    redirectUrl,
    className,
    ...props
}) {
    const dispatch = useDispatch()
    const history = useHistory()
    const location = useLocation()
    const handleLogin = () => {
        !!redirectUrl && dispatch(userActions.setRedirectUrl(location.pathname))
        history.push('/app/auth/sign-in')
    }
    return (
        <Modal
            open={open}
            onRequestDismiss={onRequestDismiss}
            className={classNames(classes.authReminderModal, className)}
            {...props}
        >
            <h4 className={classes.title}>Oops! You can't do that.</h4>
            <p className={classes.subtitle}>
                You need to be logged in to perform that action
            </p>
            <div className={classes.buttons}>
                <Button onClick={handleLogin}>Login</Button>
                <Button
                    onClick={onRequestDismiss}
                    variant={ButtonVariants.secondaryOutline}
                >
                    Cancel
                </Button>
            </div>
        </Modal>
    )
}
